import * as React from "react";

import OldSiteBanner from "./OldSiteBanner";
import OldSiteOverlay from "./OldSiteOverlay";

const OldSiteNotice = () => (
  <>
    <OldSiteBanner />
    <OldSiteOverlay />
  </>
);

export default OldSiteNotice;
